import choithramsRecipeOne from '../../assets/images/home-assets/choithramsRecipeOne/choithramsRecipeOne.png';
import choithramsRecipeTwo from '../../assets/images/home-assets/choithramsRecipeTwo/choithramsRecipeTwo.png';
import choithramsRecipeThree from '../../assets/images/home-assets/choithramsRecipeThree/choithramsRecipeThree.png';

import choithramsLayerOne from '../../assets/images/home-assets/choithramsLayerOne/choithramsLayerOne.png';
import choithramsLayerTwo from '../../assets/images/home-assets/choithramsLayerTwo/choithramsLayerTwo.png';
import choithramsLayerThree from '../../assets/images/home-assets/choithramsLayerThree/choithramsLayerThree.png';
import choithramsLayerFour from '../../assets/images/home-assets/choithramsLayerFour/choithramsLayerFour.png';

export const recipeVideos = [
    {
        'id': 1,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    },{
        'id': 2,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    },{
        'id': 3,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    },{
        'id': 4,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    },{
        'id': 5,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    }
];

export const favouriteRecipesVideos = [
    {
        'id': 1,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    },{
        'id': 2,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    },{
        'id': 3,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    },{
        'id': 4,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    },{
        'id': 5,
        'recipeVideo': `https://www.youtube.com/embed/recipe.mp4`,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeSteps': '12 Steps',
        'recipeTime': '12:43'
    }
];

export const relatedRecipes = [
    {
        'id': 1,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 2,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 3,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeThree,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 4,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 5,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    }
];

export const favouriteRecipesList = [
    {
        'id': 1,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 2,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 3,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeThree,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 4,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 5,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    }
];

export const latestRecipes = [
    {
        'id': 1,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 2,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 3,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeThree,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 4,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 5,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    }
];

export const editorsChoice = [
    {
        'id': 1,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 2,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 3,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeThree,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 4,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 5,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    }
];

export const easyToCook = [
    {
        'id': 1,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 2,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 3,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeThree,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 4,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 5,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    }
];

export const bestOfChoithrams = [
    {
        'id': 1,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 2,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 3,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeThree,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 4,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 5,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    }
];

export const course = [
    {
        'id': 1,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 2,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 3,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeThree,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 4,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeTwo,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    },{
        'id': 5,
        'recipeDate': '03',
        'recipeMonth': 'Nov',
        'recipeImage': choithramsRecipeOne,
        'recipeCategory': 'CHINESE - SIDES',
        'recipeTitle': 'Refreshing watermelon, feta and mint salad',
        'recipeDescription': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
        'recipePeople': '4 People',
        'recipeTime': '30 Min'
    }
];

export const cuisineItems = [
    {
        image: choithramsLayerOne
    },{
        image: choithramsLayerTwo
    },{
        image: choithramsLayerThree
    },{
        image: choithramsLayerFour
    },{
        image: choithramsLayerOne
    },{
        image: choithramsLayerTwo
    },{
        image: choithramsLayerThree
    },{
        image: choithramsLayerFour
    }
];
